export default __webpack_public_path__ + "static/media/agate_agnidus_d_gemstone.f23ea18b.png";